import React from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';

import EventsView from '../../components/event/View';
import {
  getEventIds,
  getEvents,
  getEventsCsv,
  getEventsExecuteId,
  getEventsGroupColumn,
  getExecuteIdsFromJobIds,
  isEventsExecuting,
} from '../../reducers/analyticsApp';
import { PARAM_CSV } from '../../utils/csv';
import { addEvent, executeEventQueries, setEventExecuteId } from '../../actions/events/events';
import { downloadCsvResult } from '../../actions/events/csvEvents';
import CsvForm from '../navigation/csv/CsvForm';
import { isValidEvent } from '../../utils/event/common';
import { cancelRequest } from '../../api/execute';
import CsvRequests from '../navigation/csv/CsvRequests';
import CsvDownloadButton from '../navigation/csv/CsvDownloadButton';

const isDisableDownloadCsv = (state) =>
  Object.entries(getEventsCsv(state)).every(([param, val]) =>
    param === PARAM_CSV.HEADER ? true : !val
  );

const isExecuteDisabled = (state) => {
  const events = getEvents(state);
  return events.some((event) => !isValidEvent(event)) || !getEventsGroupColumn(state);
};

const mapStateToProps = (state) => {
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = getEventsExecuteId(state);

  return {
    executing: isEventsExecuting(state),
    eventIds: getEventIds(state),
    executeDisabled: isExecuteDisabled(state),
    cancelButtonDisabled: !executeIds.includes(executeId),
    executeId,
    extraActions: [
      { renderElement: () => <CsvForm /> },
      {
        renderElement: (closeMenu) => (
          <CsvDownloadButton
            title="Download CSV"
            clickHandler={downloadCsvResult}
            disabled={isDisableDownloadCsv(state)}
            closeMenu={closeMenu}
          />
        ),
      },
      { renderElement: (closeMenu) => <CsvRequests closeMenu={closeMenu} /> },
    ],
  };
};

const mapDispatchToProps = (dispatch) => ({
  onEventAdd: () => dispatch(addEvent()),
  onExecute: () => {
    const executeId = v4();
    dispatch(setEventExecuteId(executeId));
    return dispatch(executeEventQueries(executeId));
  },
  onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventsView);
